import Axios from 'axios';
import { useTranslation } from 'react-i18next';
import { makeUseAxios } from 'axios-hooks';
import { useDispatch, useSelector } from 'react-redux';

import { logout } from 'redux/actions/authActions';
import {
  changeDefaultLanguage,
  changeDefaultLanguageCustom,
  changeSearchValue,
} from 'redux/actions/topBarActions';

function useApi() {
  const dispatch = useDispatch();
  const { isCustomer, i18, authToken } = useSelector((state) => state.auth);
  const { selectedDefaultLanguageCustom } = useSelector((state) => state.topBar);
  const { i18n } = useTranslation();
  const ourRequest = Axios.CancelToken.source();

  const customArea = Axios.create({
    baseURL: window.REACT_APP_SERVER_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/plain',
      Authorization: `Bearer ${authToken}`,
    },
    timeout: 60 * 10 * 1000,
    cancelToken: ourRequest.token,
  });
  const customAreaApi = makeUseAxios({
    axios: customArea,
  });

  // response interceptor intercepting 401 responses, refreshing token and retrying the request
  customArea.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { config } = error;
      if (error?.response?.status === 401 && !config?.retry) {
        config.retry = true;
        dispatch(logout());
        i18n.changeLanguage(isCustomer ? selectedDefaultLanguageCustom : i18);
        dispatch(changeDefaultLanguage(null));
        dispatch(changeDefaultLanguageCustom(null));
        dispatch(changeSearchValue(''));
        return Axios(config);
      }

      return Promise.reject(error);
    }
  );

  const account = Axios.create({
    baseURL: `${window.PATH_GW_ACC}/${window.API_V2}/`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/plain',
      Authorization: `Bearer ${authToken}`,
    },
    timeout: 60 * 10 * 1000,
  });
  const accountApi = makeUseAxios({
    axios: account,
  });

  const lexon = Axios.create({
    baseURL: `${window.PATH_GW_LEX}/${window.API_V1}/`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/plain',
      Authorization: `Bearer ${authToken}`,
    },
    timeout: 60 * 10 * 1000,
  });
  const lexonApi = makeUseAxios({
    axios: lexon,
  });

  return { customAreaApi, accountApi, lexonApi, ourRequest };
}

export default useApi;
